import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { GetVariant } from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';

const categories = [
  { id: 1, name: 'Cancellation Fee' },
  { id: 2, name: 'Late Fee' },
  { id: 3, name: 'No Show Fee' },
  { id: 4, name: 'Other' },
];

export default function PaymentCategoryTypeField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<GetVariant<'regular'>>();

  return (
    <Controller
      control={control}
      name="payment_category_type_id"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <Select {...field} displayEmpty value={value ?? ''} error={!!errors.payment_category_type_id}>
            {categories.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          {!!errors.payment_category_type_id && (
            <FormHelperText error>{`${errors.payment_category_type_id.message}`}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
